import rimg from '@pixelunion/rimg-shopify';
import Masonry from 'masonry-layout';
import themeUtils from '../themeUtils';

export default class MasonryGrid {
  constructor(options) {
    this.$el = options.$el;
    this.layout = this.layout.bind(this);
    rimg.watch(this.$el[0]);


    const defaultSettings = {
      itemSelector: '[data-masonry-item]',
      columnWidth: '[data-masonry-sizer]',
      gutter: 0,
      percentPosition: false
    };

    this.settings = themeUtils.extend(defaultSettings, options.settings);
    this.masonry = new Masonry(this.$el[0], this.settings);
    this.layout();
    this.$el.on('rimg:load', () => {
      this.layout();
    });
  }

  layout() {
    this.masonry.layout();
  }

  unload() {
    this.masonry.destroy();
    this.$el.off('rimg:load');
  }
}
